import { useState, useEffect, useCallback } from 'react';
import { SplashScreen } from '@syntra/ui/components/loading-screen';

import { useRouter } from 'src/routes/hooks';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const { loading } = useAuthContext();

  return <>{loading ? <SplashScreen /> : <Container>{children}</Container>}</>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
  const router = useRouter();

  const { authenticated, loading } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      // Redirect to home page or show login modal
      // Since we're using Auth0, users should use LoginButton component
      router.replace('/');
    } else {
      setChecked(true);
    }
  }, [authenticated, router]);

  useEffect(() => {
    if (!loading) {
      check();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
